import {
  LOGIN,
  SET_LOGIN_ERRORS,
  LOGOUT,
  SET_MESSAGE_SENT_ERRORS,
  SET_GROUP_CHAT_CREATION_ERRORS,
  SET_COMMON_ERRORS
} from '@/store/modules/user/types';

export default {
  [LOGIN]: (state, data) => {
    state.loggedIn = true;
    state.errorsLogin = [];
    Object.assign(state, data);
  },
  [SET_LOGIN_ERRORS]: (state, errors) => {
    state.errorsLogin = errors;
  },
  [LOGOUT]: state => {
    Object.keys(state).forEach(key => {
      state[key] = null;
    });
    state.loggedIn = false;
    state.errorsLogin = [];
    state.errorsCommon = [];
  },
  [SET_MESSAGE_SENT_ERRORS]: (state, errors) => {
    state.messageSentErrors = errors;
  },
  [SET_GROUP_CHAT_CREATION_ERRORS]: (state, errors) => {
    state.grouChatCreationErrors = errors;
  },
  [SET_COMMON_ERRORS]: (state, errors) => {
    state.errorsCommon = errors;
  }
};
